<template>
  <div class="middle cadfm-flexitem-stretched">

    <action-panel>
      <action-bar>
        <b-navbar-nav>
          <!-- <action-button  v-if="isPlugin||isAgent" @click="checkLocalProject"  icon="open" bold :text="lang.button_Open"
            :tooltip="lang.button_Open" :disabled="openButtonStatus"/>
          <action-button  v-if="isPlugin||isAgent" @click="push"  icon="import" bold :text="lang.button_Push"
            :tooltip="lang.button_Push" :disabled="pushButtonStatus"/>   -->
          <!-- <action-button @click="checkIn"  icon="open" bold :text="lang.button_CheckIn"
            :tooltip="lang.button_CheckIn" :disabled="checkoutButtonStatus"/>
          <action-button @click="checkOut"  icon="import" bold :text="lang.button_CheckOut"
            :tooltip="lang.button_CheckOut" :disabled="checkinButtonStatus"/>   -->
          <action-button v-if="currentUser.role != 'Reader'" @click="_new" icon="new" bold :text="lang.button_New"
            :tooltip="lang.button_New" :disabled="newButtonStatus" />
          <action-button @click="details" icon="details-part" bold :text="lang.button_Details"
            :tooltip="lang.button_Details" :disabled="detailsButtonStatus" />
          <action-button v-if="currentUser.role != 'Reader'" @click="derive" icon="derive" bold
            :text="lang.button_Derive" :tooltip="lang.button_Derive" :disabled="deriveButtonStatus" />
          <action-button v-if="currentUser.role=='Admin' && globalSettings.deletionOfElements" @click="_delete"
            icon="remove" bold :text="lang.button_Delete" :tooltip="lang.button_Delete"
            :disabled="deleteButtonStatus" />

          <action-button v-if="currentUser.role=='Admin'" @click="moveTo" icon="move-to" bold :text="lang.button_MoveTo"
            :tooltip="lang.button_MoveTo" :disabled="moveToButtonStatus" />

          <!-- <action-button  @click="withdraw"  icon="withdraw" bold :text="lang.button_Withdraw" -->
          <!-- :tooltip="lang.button_Withdraw" :disabled="withdrawButtonStatus"/> -->

          <!-- <action-button v-if="!isPlugin"  @click="pull"  icon="download" bold :text="lang.button_Pull"
            :tooltip="lang.button_Pull" :disabled="pullButtonStatus"/>
          <action-button v-if="!isPlugin"  @click="push"  icon="import" bold :text="lang.button_Push"
            :tooltip="lang.button_Push" :disabled="pushButtonStatus"/> -->
          <action-button v-if="(currentUser.role=='Admin')" @click="properties" icon="properties" bold
            :text="lang.button_Properties" :tooltip="lang.button_Properties" :disabled="propertiesButtonStatus" />
          <!-- <action-button  v-if="!isPlugin" @click="offline"  icon="download" bold :text="lang.button_DownloadZIP"
            :tooltip="lang.button_DownloadZIP" :disabled="downloadZIPButtonStatus"/> -->




        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
          <action-button v-show="!$parent.isVisibleLeft" @click="toggleLeftPanel" icon="show" bold
            :text="lang.button_Left" :tooltip="lang.button_Left" :disabled="toggleButtonStatus" />
          <action-button v-show="!$parent.isVisibleRight" @click="toggleRightPanel" icon="show" bold
            :text="lang.button_Right" :tooltip="lang.button_Right" :disabled="toggleButtonStatus" />

        </b-navbar-nav>

      </action-bar>

      <action-content>
        <Content :lang="lang.Content"></Content>
      </action-content>
    </action-panel>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ActionBar from "@/components/shared/ActionBar";
import ActionButton from "@/components/shared/ActionButton";
import ActionContent from "@/components/shared/ActionContent";
import ActionPanel from "@/components/shared/ActionPanel";
import TitleComponent from "@/components/shared/TitleComponent";
import Content from "@/components/ProjectManager/Views/ProjectTable/Middle/Content/Content";


export default {
  name: "Middle",
  components: {
    ActionBar,
    ActionButton,
    ActionContent,
    ActionPanel,
    TitleComponent,
    Content
  },
  props: {
    
    lang: Object
  },
  data() {
    return {
      detailsButtonStatus: true,
      deriveButtonStatus: true,
      deleteButtonStatus: true,
      newButtonStatus: false,
      //withdrawButtonStatus: true,
      // checkoutButtonStatus: true,
      // checkinButtonStatus: true,
      openButtonStatus: true,
      pushButtonStatus: true,
      moveToButtonStatus: true,
      propertiesButtonStatus: false,
      downloadZIPButtonStatus: false,
      toggleButtonStatus: false,

      lockedRevisionId: ""
    };
  },
  created() {},
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      selectedRows: "selectedRows",
      isPlugin: "isPlugin",
      isAgent: "isAgent",
      appConf: "appConf",
      globalSettings: "globalSettings"
    }),
    isOwner(){
      
      if (this.$store.getters.selectedRows.length == 0){
        return false;
      }
      return this.$store.getters.selectedRows[0].col___revisionId.userId == this.$store.getters.currentUser.userId;
    },
    revisionId() {
      return this.$store.getters.selectedRows[0].col___revisionId.revisionId
    }
  },
  watch: {
    selectedRows: {
      handler: function(newVal, oldVal){
        //for details button
        if (this.selectedRows.length == 1) {
          this.detailsButtonStatus = false;
        } else {
          this.detailsButtonStatus = true;
        }
        //for withdraw button
        // if (this.selectedRows.length > 0) {
        //   this.withdrawButtonStatus = false;
        // } else {
        //   this.withdrawButtonStatus = true;
        // }
        // if (this.selectedRows.length == 1 && this.selectedRows[0].col___status.value.display == "pending") {
        //   this.checkoutButtonStatus = false;
        // } else {
        //   this.checkoutButtonStatus = true;
        // }
        // if (this.selectedRows.length == 1 && this.selectedRows[0].col___status.value.display != "pending") {
        //   this.checkinButtonStatus = false;
        // } else {
        //   this.checkinButtonStatus = true;
        // }
        if (this.selectedRows.length > 0) {
          this.openButtonStatus = false

        } else {
          this.openButtonStatus = true
        }
        if (this.selectedRows.length > 0 && this.isOwner) {
          this.pushButtonStatus = false

        } else {
          this.pushButtonStatus = true
        }

        // if (this.selectedRows.length > 0){
        //   this.downloadZIPButtonStatus = false

        // }else{
        //    this.downloadZIPButtonStatus = true
        // }
        //for derive button
        if (this.selectedRows.length == 1) {
          this.deriveButtonStatus = false

        } else {
          this.deriveButtonStatus = true
        }
        //for delete button
        if (this.selectedRows.length > 0) {
          this.deleteButtonStatus = false

        } else {
          this.deleteButtonStatus = true
        }
        //for move button
        if (this.selectedRows.length > 0) {
          this.moveToButtonStatus = false

        } else {
          this.moveToButtonStatus = true
        }
      },
      deep: true
    
      
    },
    
  },
  methods: {
    checkOut(){

    },
    checkIn(){

    },
    details() {
      this.$store.dispatch("editPropertiesForm", false);


      let to = "/ProjectManager/ProjectDetails";

       let routingObject = {
        from: this.$route.path,
        to: to,
        revisionId: this.revisionId,
        id: this.$store.getters.selectedRows[0].col___revisionId.projectId,
        sourceType: "main", //"details"
        sourceId: "",
        sourceRevisionId: "",
        end: true
      }

      this.$store.commit("FORWARDROUTINGDATA", routingObject)

      // const query = {
      //   from: this.$route.path,
      //   to: to,
      //   revisionId: this.revisionId,
      //   id: this.$store.getters.selectedRows[0].col___revisionId.projectId
      // }

      this.$router.push({ path: to, query: routingObject });
    },
    _new() {

      let to = "/ProjectManager/ProjectNew";



      const query = {
        from: this.$route.path,
        to: to,
        
      }

      this.$router.push({ path: to, query: query });
    },
    _delete(){
      
      let vue = this;

      
      let deleteProjectFunc = function () {
        vue.$store.dispatch("showLoader", { visible: true, text: "wait" });
        let selectedRows = [];
        for (let i = 0, lei = vue.$store.getters.selectedRows.length; i < lei; i++){
          selectedRows.push(vue.$store.getters.selectedRows[i].col___revisionId.projectId);
        }

        const arr = {
          projectIds: selectedRows
        }
        
        vue.$store.dispatch( vue.$store.getters.sectionPrefix + "_bulkDeleteProject", arr)
        .then((result) =>{

          console.log(result)
          vue.$store.dispatch("showLoader", { visible: false, text: "" });
          let obj = {};
          if (result.status == "OK") {
            
            

            if (result.data != null) {

                let tab = [];
                for (let i = 0, lei = result.data.length; i < lei; i++) {

                  if (result.data[i].success == false) {
                    tab.push(result.data[i]);
                  }

                }
                if (tab.length > 0) {
                  const obj = {
                    title: vue.lang.modal_title_BulkFeedback,
                    text: "",
                    type: "bulk_feedback",
                    buttons: 1,
                    buttonName: vue.lang.modal_button_Close,
                    size: "xl",
                    lang: vue.lang.modal_BulkFeedback,
                    funcNo: "",
                    funcYes: "",
                    funcCustom: "",
                    data: { data: tab }
                  };
                  vue.$store.dispatch("showModalComponent", obj);
                } else {
                  obj = {
                    text: vue.lang.alert_success_delete_project,
                    time: 10,
                    type: "success"
                  }
                }

              
              

              const reloadObj = {
                    status: true,
                    name: "DataTableFilteredOnApiProjComponent"
                }
              vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

            }else{
              obj = {
                text: vue.lang.alert_error_delete_project + ".",
                time: 15,
                type: "danger"
              }

            }
          }else{
            obj = {
              text: vue.lang.alert_error_delete_project + ": " + result.message,
              time: 15,
              type: "danger"
            }

          }
          vue.$store.dispatch("displayFooterAlert", obj);
        })



      }

      const obj = {
        title: "Deleting",
        text: this.lang.alert_delete,
        type: "sure",
        buttons: 2,
        size: "sm",
        funcYes: deleteProjectFunc,
        funcNo: ""
      };

      this.$store.dispatch("showAlert", obj);
    },
    derive() {

      let to = "/ProjectManager/ProjectDerive";

      
      let revisionId = 0;
      let id = 0;
      if (this.$store.getters.selectedRows != undefined) {
        revisionId = this.$store.getters.selectedRows[0].col___revisionId.revisionId;
        id = this.$store.getters.selectedRows[0].col___revisionId.projectId;
      }

      // let to = "/ProjectManager/ProjectDetails";

      let routingObject = {
        from: this.$route.path,
        to: to,
        revisionId: revisionId,
        id: id,
        sourceType: "main", //"details"
        sourceId: "",
        sourceRevisionId: "",
        end: true,
        source: "ProjectTable",
      }
  
      this.$store.commit("FORWARDROUTINGDATA", routingObject)



      

      this.$router.push({ path: to, query: routingObject });
    },
    
    checkLocalProject(){
      let vue = this;
      
      this.lockedRevisionId = this.$store.getters.selectedRows[0];

      const obj = {
        revisionId: this.$store.getters.selectedRows[0].col___revisionId.revisionId,
        type:this.$store.getters.selectedRows[0].col___projectType.value.display,
        name:this.$store.getters.selectedRows[0].col___name.value.display,
        category:this.$store.getters.selectedRows[0].col___revisionId.category
      }

      this.$store.dispatch(this.$store.getters.sectionPrefix + "_checkProject", obj)
      .then((result) => {
        console.log(result);
        if (result.status == "OK"){

          let files = result.data.localFiles.filter(elem => elem.depth > 1);
          let path = result.data.localPath;

          if (files.length > 0){
            let funcYes = function(){
              
              
            
              vue.open();
           
            }

            const obj = {
              title: vue.lang.alert_title_openProject,
              text: vue.lang.alert_openProject_1 + " (" + path + "). " + vue.lang.alert_openProject_2,
              type: "question",
              buttons: 2,
              size: "lm",
              funcYes: funcYes,
              funcNo: "",

            }
    
            vue.$store.dispatch("showAlert", obj);
          }else{
            vue.open();
          }
        
        }else{

          let obj = {
            text: vue.lang.alert_error_CheckProject + ": " + result.message,
            time: 15,
            type: "danger"
          }

          vue.$store.dispatch("displayFooterAlert", obj);
        }
        
      })
        

    },
    open() {
      let vue = this;

      this.lockedRevisionId = this.$store.getters.selectedRows[0];

      const obj = {
        revisionId: this.$store.getters.selectedRows[0].col___revisionId.revisionId,
        type: this.$store.getters.selectedRows[0].col___projectType.value.display,
        name: this.$store.getters.selectedRows[0].col___name.value.display,
        category: this.$store.getters.selectedRows[0].col___revisionId.category
      };
   
      this.$store
        .dispatch(this.$store.getters.sectionPrefix + "_openProject", obj)
        .then(result => {
          console.log(result);

          if (result.status == "OK") {
            let obj = {
              text: "",
              time: 10,
              type: "success"
            };

            if (result.data.pullLibraryFilesResult == null) {
              obj = {
                text: "Error",
                time: 15,
                type: "danger"
              }
              vue.$store.dispatch("displayFooterAlert", obj);
              return;
            }

            if (result.data.pullLibraryFilesResult.status == "OK") {
              obj = {
                text:
                  vue.lang.alert_success_OpenProject +
                  " " +
                  result.data.pullLibraryFilesResult.data.localPath,
                time: 10,
                type: "success"
              };
            } else {
              obj = {
                text:
                  vue.lang.alert_error_OpenProject +
                  result.data.pullLibraryFilesResult.message,
                time: 15,
                type: "danger"
              };
            }

            vue.$store.dispatch("displayFooterAlert", obj);
          } else {
            let obj = {
              text: vue.lang.alert_error_OpenProject + ": " + result.message,
              time: 15,
              type: "danger"
            };

            vue.$store.dispatch("displayFooterAlert", obj);
          }
        });
    },
    push() {
      let vue = this;

     
      this.lockedRevisionId = this.$store.getters.selectedRows[0];

      const obj = {
        revisionId: this.$store.getters.selectedRows[0].col___revisionId.revisionId,
        type: this.$store.getters.selectedRows[0].col___projectType.value.display,
        name: this.$store.getters.selectedRows[0].col___name.value.display,
        category: this.$store.getters.selectedRows[0].col___revisionId.category
      };

      this.$store
        .dispatch(this.$store.getters.sectionPrefix + "_pushProject", obj)
        .then(result => {
          console.log(result);

          if (result.status == "OK") {
            
            // result.data.lockedRevisionId = vue.lockedRevisionId.col___revisionId.revisionId;

            // let func = function() {
            //   if (result.data.newRevisionId == null) {
            //   } else {
            //     vue.goTo();
            //   }
            // };

            // const obj = {
            //   title: vue.lang.modal_title_PushProject,
            //   text: "",
            //   type: "push_files",
            //   buttons: 1,
            //   buttonName: "Close",
            //   size: "xl",
            //   lang: vue.lang.modal_PushProject,
            //   funcNo: "",
            //   funcYes: "",
            //   funcCustom: func,
            //   data: result.data
            // };
            // vue.$store.dispatch("showModalComponent", obj);
            let obj = {
              text: vue.lang.alert_success_PushProject,
              time: 10,
              type: "success"
            };

            vue.$store.dispatch("displayFooterAlert", obj);
          } else {
            let obj = {
              text: vue.lang.alert_error_PushProject + ": " + result.message,
              time: 15,
              type: "danger"
            };

            vue.$store.dispatch("displayFooterAlert", obj);
          }
        });
    },
    goTo() {
      let to = "/ProjectManager/ProjectDetails";

      const obj = {
        col___revisionId: {
          revisionId: this.lockedRevisionId.col___revisionId.revisionId,
          libraryId: this.lockedRevisionId.col___revisionId.projectId
        },
        col___revision: {
          revisionId: this.lockedRevisionId.col___revision.value.display
        },
        col___status: {},
        col___image: {},
        col___name: {}
      };

      this.$store.dispatch("setSelectedRows", [obj]);

      this.$store.dispatch("setOuterData", true);

      this.$store.dispatch("editPropertiesForm", false);


      
      const query = {
        from: this.$route.path,
        to: to,
        pushed: true
      }

      this.$router.push({ path: to, query: query });
    },
    moveTo() {
      

      let vue = this;

      
      let funcYes = function (e) {
        vue.$store.dispatch("showLoader", { visible: true, text: "wait" });
        let newMovingCategory = vue.$store.getters.newMovingCategory;

        let selectedRows = [];
        for (let i = 0, lei = vue.$store.getters.selectedRows.length; i < lei; i++) {
          selectedRows.push(vue.$store.getters.selectedRows[i].col___revisionId.projectId);
        }

        
        let obj = {
          projectIds: selectedRows,
          categoryId: newMovingCategory.categoryId
        }

        if (obj.categoryId == undefined) {
          let obj = {
            text: vue.lang.alert_error_MoveProjectCategory,
            time: 15,
            type: "danger"
          };

          vue.$store.dispatch("displayFooterAlert", obj);
          vue.$store.dispatch("showLoader", { visible: false, text: "" });
          return;
        }
        
        vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_bulkMoveToAnotherCategory", obj)
          .then(function (result) {

            console.log(result)
            vue.$store.dispatch("showLoader", { visible: false, text: "" });
            if (result.status == "OK") {
              
            

              if (result.data != null) {


                
                let tab = [];
                for (let i = 0, lei = result.data.length; i < lei; i++) {

                  if (result.data[i].success == false) {
                    tab.push(result.data[i]);
                  }

                }
                if (tab.length > 0) {
                  const obj = {
                    title: vue.lang.modal_title_BulkFeedback,
                    text: "",
                    type: "bulk_feedback",
                    buttons: 1,
                    buttonName: vue.lang.modal_button_Close,
                    size: "xl",
                    lang: vue.lang.modal_BulkFeedback,
                    funcNo: "",
                    funcYes: "",
                    funcCustom: "",
                    data: { data: tab }
                  };
                  vue.$store.dispatch("showModalComponent", obj);
                } else {
                  let obj = {
                    text: vue.lang.alert_success_MoveProject,
                    time: 10,
                    type: "success"
                  };
                  vue.$store.dispatch("displayFooterAlert", obj);
                }
                                


                //reload table
                const reloadObj = {
                  status: true,
                  name: "DataTableFilteredOnApiProjComponent"
                }
                vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
              } else {
                let obj = {
                  text: vue.lang.alert_error_MoveProject,
                  time: 15,
                  type: "danger"
                };

                vue.$store.dispatch("displayFooterAlert", obj);
              }

            } else {
              let obj = {
                text: vue.lang.alert_error_MoveProject,
                time: 15,
                type: "danger"
              };

              vue.$store.dispatch("displayFooterAlert", obj);
            }


          })

      }

      var obj = {

        text: "",
        type: "moving",
        buttons: 2,
        size: "lg",
        lang: this.lang.modal_Moving,
        funcNo: "",
        funcYes: funcYes
      };
      this.$store.dispatch("showModalComponent", obj);

      

    },
    properties() {


      let to = "/ProjectManager/Properties";
      

      const query = {
        from: this.$route.path,
        to: to,
        
      }

      this.$router.push({ path: to, query: query });
    },
    offline() {
      this.$store.dispatch("showLoader", { visible: true, text: "download" });
      let vue = this;
      let activeActions = [];
      for (
        let i = 0, lei = this.$store.getters.lm_activeActions.length;
        i < lei;
        i++
      ) {
        const obj = {
          actionId: this.$store.getters.lm_activeActions[i].actionId
        };
        activeActions.push(obj);
      }

      let obj = {
        categoryId: this.$store.getters.selectedTreeProjectItemObject
          .categoryId,
        actions: activeActions
      };
    
      this.$store
        .dispatch(
          this.$store.getters.sectionPrefix + "_getActiveLibraries",
          obj
        )
        .then(result => {
          console.log(result);
          let fileName = "LIBRARIES.ZIP";

          var a = document.createElement("a");
          a.href = URL.createObjectURL(result);
          a.download = fileName;

          document.body.appendChild(a);

          a.click();
          document.body.removeChild(a);
        })
        .then(function() {
          vue.$store.dispatch("showLoader", { visible: false });
        });
    },
    
    
    

    toggleRightPanel() {
      this.$parent.isVisibleRight = !this.$parent.isVisibleRight;
    },
    toggleLeftPanel() {
      this.$parent.isVisibleLeft = !this.$parent.isVisibleLeft;
    }
  }
};
</script>


<style scoped>
  .middle {
    border-right: 1px solid #666;
    width: 30%;
  }
</style>



// WEBPACK FOOTER //
// src/components/ProjectManager/Views/ProjectTable/Middle/Middle.vue